import axiosModule from "@/util/axios-module";
import { ResponseWrapper, ErrorWrapper } from "./util";

export class DeviceService {
  static async GetDevices() {
    try {
      const response = await axiosModule.get("/devices/list");
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async GetDeviceFilters() {
    try {
      const response = await axiosModule.get("/devices/getDeviceFilters");
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async GetDevice(deviceId) {
    try {
      const response = await axiosModule.get(`devices/${deviceId}`);
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async GetApplications() {
    try {
      const response = await axiosModule.get("/ApplicationLibraries/list");
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async RemoveApplication(id) {
    try {
      const response = await axiosModule.deleteReq(
        `/ApplicationLibraries/${id}`
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async AddApplication(data) {
    try {
      const formData = new FormData();
      formData.append("Title", data.title);
      formData.append("ApplicationFile", data.file);
      formData.append("isResignable", data.isResignable);
      const response = await axiosModule.postWithFile(
        "/ApplicationLibraries",
        formData
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async ChangeApplicationLabel(data) {
    try {
      const response = await axiosModule.post(
        "/ApplicationLibraries/addLabel",
        data
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async RenameApplication(data) {
    try {
      const response = await axiosModule.post(
        "/ApplicationLibraries/update",
        data
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async abortAppUpload() {
    axiosModule.abortFileUpload();
  }
}
